import { useEffect } from 'react';

import { LEGACY_APP_URL } from '@/utils/legacyAccess';

// Leva a conta legada para o app independente (mesma origem, prefixo /v1/).
export const LegacyAppRedirect = () => {
  useEffect(() => {
    if (LEGACY_APP_URL) {
      window.location.replace(LEGACY_APP_URL);
    }
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <p className="text-sm text-slate-500">Abrindo a nova versão do seu painel…</p>
    </div>
  );
};
